import React from "react";
export const DistanceHeader = ()=> {
    return <span>Distance(Km)</span>
};